module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-plus-fill-c8716090.svg";